import { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "demo_marca_blanca";

const DEFAULTS = {
  nombre: "Palermo Sur Propiedades",
  monograma: "PSP",
  color: "#0F172A",
  horarioCierre: 18,
  horarioApertura: 9,
};

export const COLORES = [
  { nombre: "Azul Marino", hex: "#0F172A" },
  { nombre: "Verde Bosque", hex: "#064E3B" },
  { nombre: "Cobalto", hex: "#1E3A8A" },
  { nombre: "Borgoña", hex: "#701A3B" },
  { nombre: "Grafito", hex: "#18181B" },
  { nombre: "Petróleo", hex: "#0E4C5A" },
];

const BrandContext = createContext(null);

function applyColor(hex) {
  const root = document.documentElement;
  root.style.setProperty("--brand", hex);
  root.style.setProperty("--brand-light", hex + "16");
  root.style.setProperty("--brand-fg", "#ffffff");
}

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? { ...DEFAULTS, ...JSON.parse(saved) } : DEFAULTS;
    } catch {
      return DEFAULTS;
    }
  });

  useEffect(() => {
    applyColor(brand.color);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(brand));
    } catch {}
  }, [brand]);

  const update = (patch) => setBrand((b) => ({ ...b, ...patch }));
  const reset = () => setBrand(DEFAULTS);

  return (
    <BrandContext.Provider value={{ brand, update, reset }}>
      {children}
    </BrandContext.Provider>
  );
}

export function useBrand() {
  const ctx = useContext(BrandContext);
  if (!ctx) throw new Error("useBrand debe usarse dentro de BrandProvider");
  return ctx;
}
